import React, { memo } from "react";
import DayHeader from "../DayHeader";
import PeriodRow from "../PeriodRow";
import styles from "./TimetableGrid.module.css";

const TimetableGrid = memo(
	({ weekdays, isMobile, selectedDayIndex, logs, teachers, onCellClick }) => {
		const daysToRender = isMobile ? [weekdays[selectedDayIndex]] : weekdays;
		const maxPeriods =
			isMobile && daysToRender[0] ? daysToRender[0].periodCount : 7;

		return (
			<div className={styles.timetable}>
				{!isMobile && <DayHeader weekdays={weekdays} />}

				{isMobile && daysToRender[0] && (
					<div className={styles.mobileDayHeader}>
						<div className={styles.mobileDayInfo}>
							<div className={styles.dayName}>{daysToRender[0].name}</div>
							<div className={styles.dayDate}>
								{new Date(daysToRender[0].date).toLocaleDateString("en-US", {
									month: "short",
									day: "numeric",
								})}
								{daysToRender[0].isToday && (
									<span className={styles.todayBadge}>Today</span>
								)}
							</div>
						</div>
					</div>
				)}

				<div className={styles.periodsContainer}>
					{Array.from({ length: maxPeriods }, (_, i) => (
						<PeriodRow
							key={`period-${i + 1}`}
							period={i + 1}
							days={daysToRender}
							logs={logs}
							teachers={teachers}
							onCellClick={onCellClick}
						/>
					))}
				</div>
			</div>
		);
	}
);

export default TimetableGrid;
